import { pickListPt } from '@/PrimeVue/themePreset/passThrough/pickListConfiguration';
import { datePickerPt } from '@/PrimeVue/themePreset/passThrough/datePickerConfiguration';
import buildAutoComplete from '@/PrimeVue/themePreset/passThrough/autocompleteConfiguration';
import { listboxPt } from '@/PrimeVue/themePreset/passThrough/listboxConfiguration';
import { textareaPt } from '@/PrimeVue/themePreset/passThrough/textareaConfiguration';
import { tooltipPt } from '@/PrimeVue/themePreset/passThrough/tooltipConfiguration';
import LocaleStrings from '@/PrimeVue/themePreset/types/localeStrings';

function buildPassThroughPreset(localeStrings: LocaleStrings) {
  return {
    picklist: pickListPt,
    datepicker: datePickerPt,
    autocomplete: buildAutoComplete(localeStrings),
    listbox: listboxPt,
    textarea: textareaPt,
    directives: {
      tooltip: tooltipPt
    }
  };
}

export default buildPassThroughPreset;